import React, {
	FC,
	useEffect, useState,
} from 'react';
import Loader from 'react-ts-loaders';
import _ from 'lodash';
import { MultipleContainers } from '../multipleContainers/MultipleContainers';
import { ITagGroup, TagGroupType } from '../../../../../../entities/template/private-template-tag-group/model/types';
import { workshopModuleTagGroupApi } from '../../../../../../entities/module/tag-group/workshop-module-tag-group';
import { workshopModuleTagApi } from '../../../../../../entities/module/workshop-module-tag';

/**
 * Компонент - Модальное окно настройки тегов модулей мастерской
 */
export const WorkshopModulesTagSettings: FC = () => {
	const [groups, setGroups] = useState<ITagGroup[]>([]);

	const {
		isLoading: isLoadingTagGroups,
		data: tagGroupsData,
	} = workshopModuleTagGroupApi.useGetWorkshopGroupsQuery({
		page: 1,
		limit: 127,
	});
	const {
		isLoading: isLoadingTagsWithoutGroups,
		data: tagsWithoutGroupsData,
	} = workshopModuleTagApi.useGetTagsWithoutGroupsQuery({
		limit: 127,
		page: 1,
	});

	// для теста
	// const mockGroups = [{
	// 	id: '5f3a1f98-d31f-4d63-8917-76a0d6f09270',
	// 	name: 'групко',
	// 	tags: [
	// 		{
	// 			id: 5,
	// 			name: 'терминатор',
	// 			sequenceNumber: 2,
	// 		},
	// 		{
	// 			id: 8,
	// 			name: 'велосипед',
	// 			sequenceNumber: 0,
	// 		},
	// 	],
	// }];

	// Объединяем состояния загрузки
	const isLoading = isLoadingTagGroups || isLoadingTagsWithoutGroups;

	useEffect(() => {
		setGroups(() => {
			const items = _.cloneDeep(tagGroupsData?.tagGroups) ?? [];
			const unbind = _.cloneDeep(tagsWithoutGroupsData?.moduleTags) ?? [];
			items.unshift({
				id: TagGroupType.tagsWithoutGroup,
				name: 'Без группы',
				tags: unbind,
			});
			return items;
		});
	}, [tagsWithoutGroupsData?.moduleTags, tagGroupsData]);

	if (isLoading) {
		return (
			<Loader
				type="roller"
				color="rgba(57, 150, 218, 1)"
				size={100}
				className="alt-loader"
			/>
		);
	}

	return (
		<div>
			{groups
				? (
					<MultipleContainers
						handle
						items={groups}
					/>
				)
				: 'Загрузка'}
		</div>
	);
};
